import { Compiler, Component, Inject, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { DataBagService } from '../data-bag.service';
import { EmailContentService } from '../email-content.service';
import { HttpClientService } from '../http-client.service';
import { LoaderComponent } from '../loader/loader.component';
import { ReadPec, ReadPecResp, TextLogo, TextLogoResp } from '../models';
import { SharedModule } from '../shared/shared.module';
import { TokenHolder, TOKEN_HOLDER } from './communication-button/TokenHolder';
import { remoteTemplateParser } from './remoteTemplateParser';

@UntilDestroy()
@Component({
  selector: 'app-email-content',
  templateUrl: './email-content.component.html',
  styleUrls: ['./email-content.component.css']
})
export class EmailContentComponent implements OnInit {
  content$: Observable<TextLogoResp>;
  textLogo: TextLogo;
  userName = '';
  userMessage = '';
  loading = true;

  displayLegacyButton = false;

  @ViewChild('container', { read: ViewContainerRef, static: false })
  container: ViewContainerRef;
  loaderModal;

  constructor(
    private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private emailContentService: EmailContentService,
    private compiler: Compiler,
    private dataBag: DataBagService,
    @Inject(TOKEN_HOLDER) private tokenHolder: TokenHolder
  ) {}

  ngOnInit(): void {
    this.content$ = this.httpClientService.retrieveTextAndLogo(this.token);
    this.content$
    .pipe(
        untilDestroyed(this),
        tap((resp) => {
          if (!resp.success) {
            alert('error: ' + resp.error);
          } else {
            this.textLogo = resp.data;
            this.dataBag.footer = this.textLogo.footer
            const posIndex = this.textLogo.welcomeText.indexOf('<br');
            this.userMessage = this.textLogo.welcomeText.substring(posIndex, this.textLogo.welcomeText.length); 
            this.userName = this.textLogo.welcomeText.substring(0, posIndex);
          }
        }),
        catchError((err) => {
          this.router.navigate(['/issue']);
          return throwError(err);
        })
      )
      .subscribe();
    this.loaderModal = this.modalService.open(LoaderComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    this.loading = true;
    this.httpClientService
      .readPecContent(this.token)
      .pipe(
        map(data => remoteTemplateParser(data)),
        untilDestroyed(this),
        tap(([isLegacy, resp]) => {
          this.loaderModal.dismiss();
          this.loading = false;
          if (resp.success !== undefined) {
            if (resp.success) {
              this.readPec = resp.data;
              this.createComponent(resp.data.body, this.token);
              this.displayLegacyButton = isLegacy;
            } else {
              this.retryReadPec();
              // this.router.navigate(['/issue']);
            }
          }
        }),
        catchError((err) => {
          // this.loaderModal.dismiss();
          // this.loading = false;
          // this.router.navigate(['/issue']);
          this.retryReadPec();
          return throwError(err);
        })
      )
      .subscribe();
  }

  retryReadPec(): void {
    this.httpClientService
      .readPecContent(this.token)
      .pipe(
        map(data => remoteTemplateParser(data)),
        untilDestroyed(this),
        tap(([isLegacy, resp]) => {
          this.loaderModal.dismiss();
          this.loading = false;
          if (resp.success !== undefined) {
            if (resp.success) {
              this.readPec = resp.data;
              this.createComponent(resp.data.body, this.token);
              this.displayLegacyButton = isLegacy;
            } else {
              this.retryReadPec();
              // this.router.navigate(['/issue']);
            }
          }
        }),
        catchError((err) => {
          // this.loaderModal.dismiss();
          // this.loading = false;
          // this.router.navigate(['/issue']);
          this.retryReadPec();
          return throwError(err);
        })
      )
      .subscribe();
  }

  downloadEnvelope(): void {
    console.log("downloading envelope")
    this.emailContentService.downloadEnvelope(this.token);
  }

  downloadFile(attachmentId: string, filename: string): void {
    console.log("downloading file")
    this.emailContentService.downloadFile(attachmentId, filename, this.token);
  }

  private createComponent(v: string, token: string): void {
    const component = Component({
      template: v,
    })( class {} );
    this.tokenHolder.value = token;
    const module = NgModule({
      imports: [BrowserModule, SharedModule],
      declarations: [component]
    })(
      class {}
    );

    this.compiler.compileModuleAndAllComponentsAsync(module).then(factories => {
      const componentFactory = factories.componentFactories.find((factory) => factory.selector === "ng-component")
      this.container.createComponent(componentFactory);
    }).catch(err => console.log(err));
  }

  get token(): string {
    return this.route.snapshot.paramMap.get('token');
  }

  get readPec(): ReadPec {
    console.log("reading pec")
    return this.emailContentService.readPec;
  }

  set readPec(value: ReadPec) {
     this.emailContentService.readPec = value;
  }
}

